const PERSIST = 'PERSIST';

export const getUser = (store) => store[PERSIST].user;
